export default {
  vipUpgrade: {
    title: 'Tahniah!!',
    message: 'Anda telah dinaikkan pangkat dari VIP{from} ke VIP{to}',
    subtitle: 'Terima kasih atas sokongan anda. Tahap baharu membawa\nperkhidmatan eksklusif dan keistimewaan khas.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
